export const SWAP_ROUTERS = [
  'Kyber',
  'ZeroX',
  'Relay',
  'Velora',
  'Fabric',
  'SplitsVaultRouter',
  'SplitsRouter',
  'NearIntents',
] as const
export type SwapRouter = (typeof SWAP_ROUTERS)[number]

export enum SwapDirection {
  SELL = 'SELL',
  BUY = 'BUY',
}
